export default __webpack_public_path__ + "static/media/retention.a024fb73.svg";